import { CPFValidation } from "../../../../helpers/validators";

const validate = (values, page) => {
	const errors = {};

	if (page === 1) {
		if (!values.document) {
			errors.document = "Campo obrigatório";
		} else if (!CPFValidation(values.document)) {
			errors.document = "CPF inválido";
		}
	}

	if (page === 3) {
		if (!values.knowAbout) {
			errors.knowAbout = "Campo obrigatório";
		} else if (values.knowAbout.value === "Outros" && !values.knowAboutOther) {
			errors.knowAboutOther = "Campo obrigatório";
		}
	}

	if (page === 4) {
		if (!values.reception) {
			errors.reception = "Campo obrigatório";
		}
		if (!values.accreditation) {
			errors.accreditation = "Campo obrigatório";
		}
		if (!values.eventLocation) {
			errors.eventLocation = "Campo obrigatório";
		}
		if (!values.easyToRegister) {
			errors.easyToRegister = "Campo obrigatório";
		}
	}

	if (page === 5) {
		if (!values.audiovisualResources) {
			errors.audiovisualResources = "Campo obrigatório";
		}
		if (!values.cleaning) {
			errors.cleaning = "Campo obrigatório";
		}
		if (!values.openingCocktail) {
			errors.openingCocktail = "Campo obrigatório";
		}
	}

	if (page === 6) {
		if (!values.expectation) {
			errors.expectation = "Campo obrigatório";
		}
		if (!values.sufficientHour) {
			errors.sufficientHour = "Campo obrigatório";
		}
		if (!values.openingCocktail) {
			errors.openingCocktail = "Campo obrigatório";
		}
	}

	if (page === 7) {
		for (const event of values.events || []) {
			if (!values[event._id]?.goodDidacticMaterial) {
				if (!errors[event._id]) {
					errors[event._id] = {};
				}

				errors[event._id].goodDidacticMaterial = "Campo obrigatório";
			}
			if (!values[event._id]?.understandableExposition) {
				if (!errors[event._id]) {
					errors[event._id] = {};
				}

				errors[event._id].understandableExposition = "Campo obrigatório";
			}
			if (!values[event._id]?.easyLearning) {
				if (!errors[event._id]) {
					errors[event._id] = {};
				}

				errors[event._id].easyLearning = "Campo obrigatório";
			}
			if (!values[event._id]?.interestAwakened) {
				if (!errors[event._id]) {
					errors[event._id] = {};
				}

				errors[event._id].interestAwakened = "Campo obrigatório";
			}
			if (!values[event._id]?.questionsAnswered) {
				if (!errors[event._id]) {
					errors[event._id] = {};
				}

				errors[event._id].questionsAnswered = "Campo obrigatório";
			}
			if (!values[event._id]?.knowledgeDemonstrated) {
				if (!errors[event._id]) {
					errors[event._id] = {};
				}

				errors[event._id].knowledgeDemonstrated = "Campo obrigatório";
			}
		}
	}

	return errors;
};

export default validate;
